import { motion, AnimatePresence } from "framer-motion";
import '../../styles/AlertModal.css';

export default function AlertModal({ message, type, isVisible, onClose }) {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.3 }}
          className={`alert-modal ${type === "success" ? "alert-success" : "alert-error"}`}
        >
          {message}
          <button onClick={onClose} className="alert-close">✕</button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}